import React from 'react';
import {connect} from "react-redux";
import {getIngredients} from "../../actions/getFirestoreData/getIngredients"
import {addIngredient} from "../../actions/updateFirestoreData/userData/addIngredient"
import {removeIngredient} from "../../actions/updateFirestoreData/userData/removeIngredient";
import traductions from "../../constants/material-table/traductions";
import MaterialTable from "material-table";
import {LinearProgress, Grid} from "@material-ui/core";


/**
 * This class contain two material table, the first one contains all available ingredients ,
 * the second one contains user's ingredients
 * user could add or delete them from is list
 */
class IngredientsTable extends React.Component {
    state = {
        ingredients: null,
        loadingIngredients: true,
        isLoading:true,
        allIngredients: [],
    };
    _isMounted = false;

    componentDidMount = async () => {
        this._isMounted=true;

        const user = await this.props.auth;
        const ingredients = user.ingredients;
        let allIngredients = await this.props.getIngredients();
        allIngredients = allIngredients.filter(ingredient => !this.props.auth.ingredients.includes(ingredient));
        if (this._isMounted) {
            this.setState({ingredients, isLoading: false, allIngredients, loadingIngredients: false});
        }
    };
    componentWillUnmount = () =>{
        this._isMounted=false;
    };

    render() {
        const {isLoading, ingredients} = this.state;
        if (!ingredients) return <LinearProgress/>;

        return (
            <Grid container direction="row" justify="space-around">
                <Grid item xs={12} sm={6}>
                    <MaterialTable
                        style={{margin: 20}} title={`Ingredients disponibles`} localization={traductions}
                        isLoading={this.state.loadingIngredients}
                        columns={[{field: "value",},]}
                        data={this.state.allIngredients.map((ingredient) => ({value: ingredient}))}
                        options={{
                            addRowPosition: "first",
                            draggable: false,
                            actionsColumnIndex: -1,
                            pageSize: 5,
                        }}
                        editable={{
                            onRowUpdate: newData =>
                                new Promise(async (resolve, reject) => {
                                    try {
                                        this.setState({ingredients: ingredients.filter(ingredient => ingredient !== newData.value)})
                                        await this.props.addIngredient(newData.value, this.props.auth)
                                        resolve();
                                    } catch (e) {
                                        reject()
                                    }
                                }),
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <MaterialTable
                    style={{margin: 20}} title={`Vos ingredients`}
                    localization={traductions} isLoading={isLoading}
                    columns={[{field: "value",},]}
                    data={ingredients.map(ingredient => ({value: ingredient}))}
                    options={{
                        addRowPosition: "first",
                        draggable: false,
                        actionsColumnIndex: -1,
                        pageSize: 5,
                    }}
                    editable={{
                        onRowDelete: oldData =>
                            new Promise(async (resolve, reject) => {
                                this.setState({ingredients: ingredients.filter(ingredient => ingredient !== oldData.value.toString())})
                                await this.props.removeIngredient(oldData.value, this.props.auth)
                                resolve();
                            })
                    }}
                    />
                </Grid>
            </Grid>
        );
    }
}


const mapStateToProps = ({auth}) => {
    return {auth}
};


export default connect(
    mapStateToProps,
    {getIngredients, removeIngredient, addIngredient}
)(IngredientsTable)
